import { useState, useEffect } from "react";
import { sendRequest } from "../../helpers";
import { NBU_API } from "../../config";
import styled from "styled-components";
import Header from "../Header/Header";
import MainDesk from "../MainDesk";
import Footer from "../Footer/Footer";

const StyledDashboard = styled.div`
background: rgb(124,74,179);
background: linear-gradient(180deg, rgba(124,74,179,1) 50%, rgba(21,27,59,1) 100%);
min-height: 100vh;
width: 100%;
position: relative;
`
const ContentContainer = styled.div`
max-width: 1200px;
margin: 0 auto;
min-height: 100vh;
`

const Dashboard = () =>{
   
   const [rateNow,setRateNow] = useState([])

    
    useEffect(()=>{
        sendRequest(NBU_API)
        .then((results) =>{
           
            
            setRateNow([results])
            
            
        })
        
    },[])
  

    

  
    return (
        <StyledDashboard>
            <ContentContainer>
                    <Header rateNow={rateNow}/>
                    <MainDesk rateNow={rateNow} />
                    <Footer/>
            </ContentContainer>
        </StyledDashboard>
    )


}

export default Dashboard;